import { render, staticRenderFns } from "./TermViewAttribute.vue?vue&type=template&id=d6483f38&scoped=true"
import script from "./TermViewAttribute.vue?vue&type=script&lang=js"
export * from "./TermViewAttribute.vue?vue&type=script&lang=js"
import style0 from "./TermViewAttribute.vue?vue&type=style&index=0&id=d6483f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6483f38",
  null
  
)

export default component.exports